import { t } from "../../../hooks/useAppTranslation";
import {useState} from 'react';
import {Document, Page, pdfjs} from 'react-pdf';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';

import {PreviewUnavailable} from './PreviewUnavailable';

pdfjs.GlobalWorkerOptions.workerSrc = '/scripts/pdf.worker.min.js';


export const Pdf = ({blobUrl}) => {
  const [pagesCount, setPagesCount] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [loadingOn, setLoadingOn] = useState(true);
  const [isPdfLoadingError, setIsPdfLoadingError] = useState(false);

  if (isPdfLoadingError) {
    return <PreviewUnavailable />
  }

  function handleDocumentLoadSuccess({ numPages }) {
    setPagesCount(numPages);
    setLoadingOn(false);
  }

  return (
    <div className="image-preview">
      <div className="image-preview__pdf">
        <Document
          file={blobUrl}
          loading={(
            <p className="info-text" role="status">
              { t('g-downloading-file-preview') }
            </p>
          )}
          onLoadError={() => {
            setIsPdfLoadingError(true);
            setLoadingOn(false);
          }}
          onLoadSuccess={handleDocumentLoadSuccess}
        >
          <Page pageNumber={pageNumber} />
        </Document>
      </div>
      {(!loadingOn && pagesCount > 1) &&
        <nav
          aria-labelledby="paginationNav"
          className="image-preview__pagination"
        >
          <h4 className="sr-only" id="paginationNav"> { t('g-auxiliary-navigation') }</h4>
          <button
            className="btn"
            disabled={pageNumber === 1}
            type="button"
            onClick={() => setPageNumber(prevState => prevState - 1)}
          >
            <span className="sr-only">{ t('table-previous-page') }</span>
            <NavigateBeforeIcon />
          </button>
          <p className="image-preview__pages">{pageNumber} / {pagesCount}</p>
          <button
              className="btn"
              disabled={pageNumber === pagesCount}
              type="button"
              onClick={() => setPageNumber(prevState => prevState + 1)}
          >
            <span className="sr-only">{ t('table-next-page') }</span>
            <NavigateNextIcon/>
          </button>
        </nav>
      }
    </div>
  )

};
